import React, { useContext, useEffect } from "react";
import ContextGeneral from "../../servicios/contexto";

const VIOLETA = "#697B68";
const ROSA = "#E09767";

export default function Loader({ setLoader }) {
  const { llamadaDB } = useContext(ContextGeneral);

  useEffect(() => {
    let timeoutId;
    const promise = llamadaDB?.();

    if (promise?.finally) {
      promise.finally(() => setLoader(false));
      return undefined;
    }

    timeoutId = setTimeout(() => setLoader(false), 1200);
    return () => clearTimeout(timeoutId);
  }, [llamadaDB, setLoader]);

  return (
    <div
      className="fixed inset-0 z-[9999] flex min-h-[100dvh] items-center justify-center px-5"
      style={{
        backgroundColor: "#EADFD2",
        backgroundImage:
          "linear-gradient(180deg, rgba(248,242,234,0.95) 0%, rgba(234,223,210,0.92) 56%, rgba(248,242,234,1) 100%)",
      }}
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(90deg, #697B68 1px, transparent 1px), linear-gradient(#697B68 1px, transparent 1px)",
          backgroundSize: "56px 56px",
        }}
      />

      <div className="relative flex w-full max-w-[220px] flex-col items-center justify-center gap-7">
        <img
          src="/logo.png"
          alt="Loader"
          className="h-24 w-24 rounded-full object-contain drop-shadow-[0_18px_30px_rgba(105,123,104,0.24)] animate-[float_1.6s_ease-in-out_infinite] sm:h-28 sm:w-28"
        />

        <div
          className="h-1 w-full max-w-40 overflow-hidden rounded-full"
          style={{ backgroundColor: `${VIOLETA}14` }}
        >
          <div
            className="h-full w-1/3 rounded-full animate-[slide_1.2s_ease-in-out_infinite]"
            style={{
              background: `linear-gradient(90deg, ${ROSA}, ${VIOLETA})`,
            }}
          />
        </div>
      </div>

      <style>{`
        @keyframes slide {
          0% { transform: translateX(-120%); }
          100% { transform: translateX(320%); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }
      `}</style>
    </div>
  );
}